export class TermSummary {
    constructor(
        public id?: string,
        public name?: string,
        public description?: string,
    ) {
    }
}
